import React, { useState } from 'react';
import { connect } from 'react-redux';

import BobPage from '../../../components/BobPage';
import BobActionMenu from '../../../components/BobActionMenu';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import IotHubViewSelector from '../../../components/IotHubViewSelector';
import IotHubTotals from '../../../components/IotHubTotals';
import Navigation from '../Navigation/Navigation';
import BasAgentView from './BasAgentView';
import FsmIntegrationView from './FsmIntegrationView';
import CreateFsmAgentModal from '../Modals/CreateFsmAgentModal';
import CreateBasAgentModal from '../Modals/CreateBasAgentModal';

import * as classes from './IotHub.module.css';

const IotHub = ({
    basAgents,
    erpAgents,
    ...props
}) => {
    const [view, setView] = useState('Bas Agents');
    const [createFsmAgentModalOpen, setCreateFsmAgentModalOpen] = useState(false);
    const [createBasAgentModalOpen, setCreateBasAgentModalOpen] = useState(false);

    return (
        <BobPage>
            <div className={classes.CompanyPage}>
                <div className={classes.BreadcrumbPanel}>
                    <Breadcrumb />
                </div>
                <div className={classes.HeaderPanel}>
                    <div className={classes.NavigationPanel}>
                        <Navigation />
                    </div>
                </div>
                <div className={classes.TitlePanel}>
                    <div className={classes.Name}>
                        IoT Hub
                    </div>
                </div>
                <div className={classes.DataPanel}>
                    <div>
                        <IotHubViewSelector view={view} handleChangeView={setView} />
                    </div>
                    <div>
                        <IotHubTotals
                            label={view === 'Bas Agents' ? 'Agents' : 'Integrations'}
                            value={view === 'Bas Agents' ? basAgents.length : erpAgents.length}
                        />
                    </div>
                    <div className={classes.ActionButtonContainer}>
                        <BobActionMenu
                            setCreateFsmAgentModalOpen={setCreateFsmAgentModalOpen}
                            setCreateBasAgentModalOpen={setCreateBasAgentModalOpen}
                            activeTab={view}
                        />
                    </div>
                </div>
                <div className={classes.TablePanel}>
                    {
                        view === 'Bas Agents' ?
                            <BasAgentView />
                            :
                            <FsmIntegrationView />
                    }
                </div>
                {
                    createBasAgentModalOpen ?
                        <CreateBasAgentModal
                            setCreateBasAgentModalOpen={setCreateBasAgentModalOpen}
                        />
                        :
                        null
                }
                {
                    createFsmAgentModalOpen ?
                        <CreateFsmAgentModal
                            setCreateFsmAgentModalOpen={setCreateFsmAgentModalOpen}
                        />
                        :
                        null
                }
            </div>
        </BobPage>
    );
};

const mapStateToProps = state => ({
    basAgents: Object.values(state.basAgent.basAgents),
    erpAgents: state.erpAgent.erpAgents
});

export default connect(mapStateToProps, null)(IotHub);
